import { Injectable } from '@angular/core';
import { CrudService } from '@appstrax/services/database';
import { OrganizationInvite } from '@models';

@Injectable({ providedIn: 'root' })
export class OrganizationInviteService extends CrudService<OrganizationInvite> {
  constructor() {
    super('organization-invites', OrganizationInvite);
  }
}

